import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import { order } from '../models/orders';
import { APIConstants } from '../app.constants';
import { CookieService } from 'ngx-cookie-service';
import { OrderDto } from '../models/OrderDto';
import { map } from 'rxjs/operators';
import { response } from '../models/response';
import { ApiResponse } from '../models/cart';
import { ThrowStmt } from '@angular/compiler';
import { ExternalRouterService } from './external-router.service';


@Injectable({
  providedIn: 'root'
})
export class OrderService {
  

  constructor(private httpClient : HttpClient, private cookie:CookieService, private externalRouterService: ExternalRouterService) { }
  readonly url = APIConstants.BASE_URL


  magicCheckout(cartId:string,productId:string):Observable<{attributes:{razorpay_order_id: string, amount: number}}>{
    return this.httpClient.post<{attributes:{razorpay_order_id: string, amount: number}}>(APIConstants.BASE_URL+"/order/magic-checkout?productId="+productId+"&cartId="+cartId,null);
  }

  advancedOrder(userId:string, billingAddressId:string, shippingAddressId:string, cartId:string, shippingIsBilling:boolean,auth:string,uniqueId:any="?", type:any="NEW_DEVICE",paymentMode:any="RAZORPAY_MAGIC_CHECKOUT"):Observable<ApiResponse<OrderDto>>{
    const body={
      "userId":userId,
      "billingAddressId":billingAddressId,
      "shippingAddressId":shippingAddressId,
      "type":type,
      "paymentMode":paymentMode,
      "cartId":cartId,
      "shippingIsBilling":shippingIsBilling,
      "source": {
        "attributes":  this.externalRouterService.getUrl()[0],
        "additionalAttr": this.cookie.get("url")
      }
    }
    
    const headers= new HttpHeaders({
      "Authorization": auth
    })
    return this.httpClient.post<ApiResponse<OrderDto>>(APIConstants.BASE_URL+"/order/create-order-v2",body, {headers:headers});
  }
  updatePayment(orderId, paymentId, auth){
    return this.httpClient.post(APIConstants.BASE_URL+"/order/capture-payment?orderId="+orderId+"&paymentId="+paymentId, null,{headers: new HttpHeaders().set("Authorization",auth)})
  }
  
  updateQbOrder(orderNo,billingAddressId, shippingAddressId):Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.cookie.get("Authorization")
    });
    const options = {headers};
    
    let update={"orderId":orderNo,"billingAddressId":billingAddressId,"shippingAddressId":shippingAddressId}
    
    return this.httpClient.put(APIConstants.BASE_URL+'/order/update/qb-order',update,options);
  }

  updateOrder(orderNo,billingAddressId, shippingAddressId):Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.cookie.get("Authorization")
    });
    const options = {headers};
    
    let update={"orderId":orderNo,"billingAddressId":billingAddressId,"shippingAddressId":shippingAddressId}
    
    return this.httpClient.put(APIConstants.BASE_URL+'/order/update-Address',update,options);
  }

  orderPickup(orderNos:Array<String>):Observable<any>{
    let headers:HttpHeaders= new HttpHeaders({
      'Content-Type':'application/json',
      'Authorization':this.cookie.get("Authorization")
    });
    
    return this.httpClient.post(APIConstants.BASE_URL+"/ship-rocket/pickup",{"order_nos":orderNos},{headers:headers});
  }
  /**
   * @deprecated createOrder method should not be used. Instead use advancedOrder
   */
  createOrder(order: order, authorization: string):Observable<any>{
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': authorization
    })
    let options = {headers:headers}
    return this.httpClient.post<any>(this.url + "/order",order,options);
  }
  capturePayament(data:any):Observable<any>{
    let headers= new HttpHeaders({"Authorization":this.cookie.get("Authorization")});
    return this.httpClient.post(this.url+"/rzp-payment/on-successful-payment",data,{ headers:headers})
  }
  captureMagicCheckoutPayament(data:any):Observable<any>{
    //let headers= new HttpHeaders({"Authorization":this.cookie.get("Authorization")});
    return this.httpClient.post(this.url+"/magic-checkout/on-successful-payment",data)
  }
  getOrder(orderNo : string, authorization: string): Observable<OrderDto>{
    let headers = new HttpHeaders({
      'Authorization': authorization
    })
    let options = {headers:headers}
    return this.httpClient.get<OrderDto>(this.url + "/order?orderNo="+orderNo, options).pipe(map((response:any)=>{return response.body}));
  }

  getAllOrders(userId: string, authorization:string): Observable<OrderDto[]> {
    let headers = new HttpHeaders({
      'Authorization': authorization
    }) 
    let options = {headers : headers}
    return this.httpClient.get<OrderDto[]>(this.url+ "/order/all?userId=" +userId, options).pipe(map((response:any)=>{
      return response.body;
    }));
  }
  
  getOrderByCartId(cartId:string):Observable<OrderDto>{
    let headers= new HttpHeaders({
      'Authorization': this.cookie.get('Authorization')
    })
    let options={headers:headers}
 
    return this.httpClient.get<OrderDto>(this.url+"/order/cart-id?cartId="+cartId,options).pipe(map((response:any)=>{return response.body}));
  }

  getPaymentByCartId(cartId:string):Observable<any>{

    let headers= new HttpHeaders({
      'Authorization': this.cookie.get("Authorization")
    })
    let options={headers: headers};
    return this.httpClient.get<any> (this.url+"/order/payment-id?cartId="+ cartId, options).pipe(map((response:any)=> {return  response.body}))
  }

}
